import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// For routes that can only be accessed by authenticated users
const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const { isLoading, currentUser } = useAuth();
  const navigate = useNavigate();
  const ssoCode = localStorage.getItem("ssoCode");

  useEffect(() => {
    if (!isLoading && !currentUser) {
      console.log("AuthGuard: redirecting to login", isLoading, currentUser);
      if (ssoCode) {
        localStorage.removeItem("ssoCode");
        navigate("/auth/sso/callback?code=" + ssoCode);
        return;
      }
      navigate("/login");
    }
  }, [isLoading, currentUser]);

  if (isLoading || !currentUser) return null;

  return <>{children}</>;
};

export default AuthGuard;
